// Alshallal brand logo. Served from /public as a transparent PNG so it sits
// cleanly on both light and dark surfaces. Use `className` to size it.
export const BrandLogo = ({ className = "", alt = "Alshallal" }) => (
    <img
        src={`${process.env.PUBLIC_URL || ""}/alshallal-logo-256.png`}
        alt={alt}
        draggable={false}
        loading="eager"
        className={className}
    />
);
